import type { EvCategoryVariantSort } from "@/features/ev/EvCategoryVariantSort";
import type { EvSetType } from "@/features/ev/EvSetType";
import type { Money } from "@/lib/domain/Money";
import { useHTTP, type PaginatedResponseModel } from "@/lib/http";
import { useHTTPQueryWithCursor } from "@/lib/http/useHTTPQueryWithCursor";

export interface EvItemBreakdownCategoryVariantResponseModel {
	readonly variantId: string;
	readonly productId: string;
	readonly setType: EvSetType;
	readonly category: string;
	readonly marketPrice: Money;
	readonly productName: string;
	readonly fcId: string;
	readonly description: string;
	readonly imageUrl: string;
	readonly shortPrintDescription: string;
}

export const useEvItemBreakdownCategoryVariants = (setType: EvSetType, category: string, sort: EvCategoryVariantSort) => {
	const http = useHTTP("Required");
	return useHTTPQueryWithCursor({
		queryKey: ["evBreakdownCategoryVariants", setType, category, sort],
		queryFn: ({ pageParam = 0 }) => {
			return http<PaginatedResponseModel<EvItemBreakdownCategoryVariantResponseModel>>({
				method: "GET",
				url: `/ev/breakdown/variants?setType=${setType}&category=${category}&sort=${sort}&cursor=${pageParam}`
			});
		}
	});
};
